module.exports = __webpack_public_path__ + "static/media/Mr Gold.b23a7662.jpg";